import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import Navbar from "./Navbar";

const EMAIL = "vmdpproject@gmail.com";
const UPDATED = "Maggio 2026";

function Section({ n, title, children }) {
  return (
    <div
      style={{
        marginBottom: "2.75rem",
        paddingBottom: "2.75rem",
        borderBottom: "1px solid var(--color-border)",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
          marginBottom: "1rem",
        }}
      >
        <span
          style={{
            fontFamily: "var(--font-mono)",
            fontSize: "0.7rem",
            fontWeight: 500,
            color: "var(--color-accent-mid)",
            background: "rgba(124,58,237,0.1)",
            border: "1px solid rgba(124,58,237,0.22)",
            borderRadius: "6px",
            padding: "3px 9px",
            flexShrink: 0,
          }}
        >
          {String(n).padStart(2, "0")}
        </span>
        <h2
          style={{
            fontFamily: "var(--font-display)",
            fontWeight: 700,
            fontSize: "clamp(1.3rem, 2.5vw, 1.6rem)",
            color: "var(--color-text)",
            letterSpacing: "-0.01em",
            margin: 0,
          }}
        >
          {title}
        </h2>
      </div>
      <div
        style={{
          color: "var(--color-text-2)",
          fontSize: "1.1rem",
          lineHeight: 1.9,
        }}
      >
        {children}
      </div>
    </div>
  );
}

const linkStyle = {
  color: "var(--color-accent-mid)",
  textDecoration: "underline",
  textUnderlineOffset: "3px",
};
const ulStyle = {
  paddingLeft: "1.25rem",
  margin: "0.75rem 0",
  display: "flex",
  flexDirection: "column",
  gap: "0.4rem",
};
const dividerStyle = {
  borderTop: "2px solid var(--color-border)",
  margin: "3.5rem 0 2.5rem",
};

function ChapterHeading({ label, title, gradient }) {
  return (
    <div style={{ marginBottom: "2.5rem" }}>
      <span
        style={{
          fontFamily: "var(--font-mono)",
          fontSize: "0.82rem",
          color: "var(--color-accent-mid)",
          letterSpacing: "0.12em",
          textTransform: "uppercase",
          display: "block",
          marginBottom: "0.75rem",
        }}
      >
        {label}
      </span>
      <h2
        style={{
          fontFamily: "var(--font-display)",
          fontWeight: 800,
          fontSize: "clamp(1.8rem, 3.5vw, 2.4rem)",
          letterSpacing: "-0.03em",
          margin: 0,
        }}
      >
        {gradient ? (
          <>
            {title.before}{" "}
            <span
              style={{
                background: "var(--gradient-text)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
              }}
            >
              {title.highlight}
            </span>
          </>
        ) : (
          title
        )}
      </h2>
    </div>
  );
}

export default function IPairlyPrivacy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Navbar />
      <motion.main
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.4 }}
        style={{ background: "var(--color-bg)", minHeight: "100vh" }}
      >
        {/* ── Hero ── */}
        <section
          style={{
            paddingTop: "68px",
            background:
              "linear-gradient(180deg, rgba(124,58,237,0.08) 0%, transparent 100%)",
            borderBottom: "1px solid var(--color-border)",
          }}
        >
          <div className="container" style={{ padding: "4rem 1.75rem 3rem" }}>
            <span
              style={{
                fontFamily: "var(--font-mono)",
                fontSize: "0.82rem",
                color: "var(--color-accent-mid)",
                letterSpacing: "0.12em",
                textTransform: "uppercase",
                display: "block",
                marginBottom: "1rem",
              }}
            >
              {"// ipairly · legale"}
            </span>
            <h1
              style={{
                fontFamily: "var(--font-display)",
                fontWeight: 800,
                fontSize: "clamp(2.2rem, 5vw, 3.2rem)",
                letterSpacing: "-0.03em",
                lineHeight: 1.1,
                marginBottom: "1rem",
              }}
            >
              Privacy, Termini{" "}
              <span
                style={{
                  background: "var(--gradient-text)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  backgroundClip: "text",
                }}
              >
                & GDPR
              </span>
            </h1>
            <p
              style={{
                fontFamily: "var(--font-mono)",
                fontSize: "0.82rem",
                color: "var(--color-muted)",
              }}
            >
              iPairly · VMDProject · Ultimo aggiornamento: {UPDATED}
            </p>
            {/* Anchor tabs */}
            <div
              style={{
                display: "flex",
                gap: "0.75rem",
                flexWrap: "wrap",
                marginTop: "1.75rem",
              }}
            >
              {[
                ["#privacy", "Privacy Policy"],
                ["#terms", "Termini di Servizio"],
                ["#gdpr", "GDPR & CCPA"],
              ].map(([href, label]) => (
                <a
                  key={href}
                  href={href}
                  style={{
                    fontFamily: "var(--font-mono)",
                    fontSize: "0.78rem",
                    fontWeight: 500,
                    color: "var(--color-accent-mid)",
                    textDecoration: "none",
                    background: "rgba(124,58,237,0.1)",
                    border: "1px solid rgba(124,58,237,0.22)",
                    borderRadius: "8px",
                    padding: "6px 14px",
                    transition: "background 0.2s",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.background = "rgba(124,58,237,0.18)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.background = "rgba(124,58,237,0.1)")
                  }
                >
                  {label}
                </a>
              ))}
            </div>
          </div>
        </section>

        {/* ── Contenuto ── */}
        <div className="container" style={{ padding: "3rem 1.75rem 5rem" }}>
          {/* ── PRIVACY POLICY ── */}
          <div id="privacy">
            <ChapterHeading
              label="// 01 · privacy policy"
              title={{ before: "Privacy", highlight: "Policy" }}
              gradient
            />

            {/* Principio fondamentale */}
            <div
              style={{
                background: "rgba(124,58,237,0.06)",
                border: "1px solid rgba(124,58,237,0.2)",
                backdropFilter: "blur(12px)",
                borderRadius: "var(--radius-lg)",
                padding: "1.5rem 1.75rem",
                marginBottom: "3rem",
                color: "var(--color-text-2)",
                fontSize: "1.1rem",
                lineHeight: 1.8,
              }}
            >
              <strong style={{ color: "var(--color-text)" }}>
                Principio fondamentale:
              </strong>{" "}
              iPairly non raccoglie, non trasmette e non vende alcun dato
              personale. Tutta l'app funziona completamente offline. I dati
              rimangono cifrati sul vostro dispositivo e non lasciano mai il
              vostro telefono.
            </div>

            <Section n={1} title="Chi siamo">
              iPairly è un'applicazione mobile sviluppata da{" "}
              <strong style={{ color: "var(--color-text)" }}>VMDProject</strong>
              . L'app è disponibile su App Store (Apple) e Google Play Store
              (Google).
              <br />
              <br />
              Per qualsiasi domanda:{" "}
              <a href={`mailto:${EMAIL}`} style={linkStyle}>
                {EMAIL}
              </a>
            </Section>

            <Section n={2} title="Dati che NON raccogliamo">
              iPairly è progettata con una filosofia privacy-first. Non
              raccogliamo:
              <ul style={ulStyle}>
                <li>
                  Nome, email o qualsiasi dato identificativo (a meno che non
                  crei un account Pro volontariamente)
                </li>
                <li>Dati di utilizzo, analytics o telemetria</li>
                <li>Cronologia di gioco o sessioni</li>
                <li>Dati di localizzazione</li>
                <li>Contatti, microfono, fotocamera</li>
                <li>Identificatori pubblicitari (IDFA/GAID)</li>
              </ul>
            </Section>

            <Section n={3} title="Dati che restano sul dispositivo">
              I seguenti dati vengono salvati localmente tramite storage cifrato
              (expo-secure-store) e non vengono mai trasmessi:
              <ul style={ulStyle}>
                <li>Nomi dei giocatori e safe word</li>
                <li>Preferenze di gioco (intensità, categorie)</li>
                <li>Cronologia delle sessioni</li>
                <li>Sfide personalizzate create dall'utente</li>
                <li>Stato degli acquisti in-app (pack, Pro)</li>
              </ul>
              Questi dati vengono eliminati disinstallando l'app.
            </Section>

            <Section n={4} title="Account opzionale (Pro)">
              La creazione di un account è completamente opzionale ed è
              disponibile solo per gli utenti Pro che desiderano il backup cloud
              delle sessioni. Se create un account:
              <ul style={ulStyle}>
                <li>
                  Raccogliamo solo l'indirizzo email per l'autenticazione
                  tramite magic link
                </li>
                <li>
                  Il backup delle sessioni è cifrato e accessibile solo a voi
                </li>
                <li>Non condividiamo l'email con terze parti</li>
                <li>
                  Potete eliminare l'account in qualsiasi momento scrivendo a{" "}
                  <a href={`mailto:${EMAIL}`} style={linkStyle}>
                    {EMAIL}
                  </a>
                </li>
              </ul>
            </Section>

            <Section n={5} title="Acquisti in-app">
              Gli acquisti (pack e abbonamento Pro) sono elaborati direttamente
              da Apple o Google. iPairly non ha accesso ai dati di pagamento. Le
              ricevute vengono salvate localmente. Per ripristinare gli acquisti
              su un nuovo dispositivo, usate la funzione "Ripristina acquisti"
              nell'app con lo stesso Apple ID o account Google.
            </Section>

            <Section n={6} title="Servizi di terze parti">
              <ul style={ulStyle}>
                <li>
                  <strong style={{ color: "var(--color-text)" }}>
                    Supabase
                  </strong>{" "}
                  — solo per utenti Pro con account: autenticazione e backup
                  cifrato (server EU, Frankfurt)
                </li>
                <li>
                  <strong style={{ color: "var(--color-text)" }}>
                    Apple App Store / Google Play
                  </strong>{" "}
                  — elaborazione pagamenti IAP
                </li>
                <li>
                  <strong style={{ color: "var(--color-text)" }}>
                    Expo / React Native
                  </strong>{" "}
                  — framework dell'app, nessuna raccolta dati aggiuntiva
                </li>
              </ul>
              Per gli utenti senza account, nessun servizio di terze parti
              riceve dati.
            </Section>

            <Section n={7} title="Sicurezza">
              I dati locali sono cifrati con expo-secure-store che utilizza le
              API native del sistema operativo (Keychain su iOS, Keystore su
              Android). I backup cloud (solo Pro) sono cifrati in transito
              tramite TLS e a riposo sui server Supabase (EU).
            </Section>

            <Section n={8} title="Minori">
              iPairly è classificata 17+ e non è destinata a utenti di età
              inferiore a 17 anni. Non raccogliamo consapevolmente dati di
              minori. Contattate{" "}
              <a href={`mailto:${EMAIL}`} style={linkStyle}>
                {EMAIL}
              </a>{" "}
              per segnalazioni.
            </Section>

            <Section n={9} title="Modifiche alla Privacy Policy">
              Ci riserviamo il diritto di aggiornare questa policy. Le modifiche
              sostanziali saranno comunicate tramite aggiornamento dell'app.
            </Section>
          </div>

          {/* ── TERMINI DI SERVIZIO ── */}
          <div id="terms">
            <div style={dividerStyle} />
            <ChapterHeading
              label="// 02 · termini di servizio"
              title={{ before: "Termini di", highlight: "Servizio" }}
              gradient
            />

            <Section n={1} title="Accettazione dei termini">
              Utilizzando iPairly accettate i presenti Termini di Servizio. Se
              non li accettate, non utilizzate l'app.
            </Section>

            <Section n={2} title="Utilizzo dell'app">
              iPairly è destinata a utenti di età pari o superiore a 17 anni.
              L'app contiene contenuti per adulti inclusi temi di intimità e
              linguaggio per adulti. L'utente è responsabile dell'uso
              appropriato e del rispetto del consenso di tutti i partecipanti.
            </Section>

            <Section n={3} title="Contenuti generati dall'utente">
              Le sfide personalizzate create dall'utente rimangono salvate solo
              localmente sul dispositivo. VMDProject non ha accesso a tali
              contenuti. L'utente è l'unico responsabile dei contenuti che crea.
            </Section>

            <Section n={4} title="Acquisti in-app">
              <ul style={ulStyle}>
                <li>
                  I pack sono acquisti non-consumabili: acquistati una sola
                  volta, senza scadenza
                </li>
                <li>
                  Il piano Pro è un abbonamento auto-rinnovabile: disdetto in
                  qualsiasi momento dalle impostazioni dello store
                </li>
                <li>
                  Non è previsto rimborso automatico; per richieste contattate
                  direttamente Apple o Google
                </li>
                <li>
                  Gli acquisti sono associati al vostro Apple ID o account
                  Google, non a iPairly
                </li>
              </ul>
            </Section>

            <Section n={5} title="Limitazione di responsabilità">
              iPairly è fornita "così com'è". VMDProject non è responsabile per
              danni derivanti dall'uso dell'app, contenuti generati dagli utenti
              o interruzioni del servizio. L'app non sostituisce consulenza
              professionale di alcun tipo.
            </Section>

            <Section n={6} title="Proprietà intellettuale">
              Tutti i contenuti dell'app (testi delle sfide, design, codice)
              sono di proprietà di VMDProject. È vietata la riproduzione o
              distribuzione senza autorizzazione scritta.
            </Section>

            <Section n={7} title="Legge applicabile">
              I presenti termini sono regolati dalla legge italiana. Per
              qualsiasi controversia è competente il{" "}
              <strong style={{ color: "var(--color-text)" }}>
                Foro di Napoli
              </strong>
              .
            </Section>

            <Section n={8} title="Contatti">
              Email:{" "}
              <a href={`mailto:${EMAIL}`} style={linkStyle}>
                {EMAIL}
              </a>
            </Section>
          </div>

          {/* ── GDPR & CCPA ── */}
          <div id="gdpr">
            <div style={dividerStyle} />
            <ChapterHeading
              label="// 03 · gdpr & ccpa"
              title={{ before: "GDPR &", highlight: "CCPA" }}
              gradient
            />

            <Section n={1} title="GDPR — Utenti europei">
              In conformità al Regolamento UE 2016/679:
              <ul style={ulStyle}>
                <li>
                  <strong style={{ color: "var(--color-text)" }}>
                    Base giuridica:
                  </strong>{" "}
                  il trattamento dei dati (solo per utenti Pro) si basa sul
                  contratto e sul consenso esplicito
                </li>
                <li>
                  <strong style={{ color: "var(--color-text)" }}>
                    Diritto di accesso:
                  </strong>{" "}
                  potete richiedere copia dei vostri dati scrivendo a{" "}
                  <a href={`mailto:${EMAIL}`} style={linkStyle}>
                    {EMAIL}
                  </a>
                </li>
                <li>
                  <strong style={{ color: "var(--color-text)" }}>
                    Diritto alla cancellazione:
                  </strong>{" "}
                  potete richiedere l'eliminazione dell'account e di tutti i
                  dati associati
                </li>
                <li>
                  <strong style={{ color: "var(--color-text)" }}>
                    Portabilità:
                  </strong>{" "}
                  esportate i vostri dati tramite la funzione Export nel piano
                  Pro
                </li>
                <li>
                  <strong style={{ color: "var(--color-text)" }}>
                    Titolare del trattamento:
                  </strong>{" "}
                  VMDProject —{" "}
                  <a href={`mailto:${EMAIL}`} style={linkStyle}>
                    {EMAIL}
                  </a>
                </li>
                <li>
                  <strong style={{ color: "var(--color-text)" }}>
                    Trasferimento dati:
                  </strong>{" "}
                  i backup cloud sono archiviati su server Supabase in EU
                  (Frankfurt, Germania)
                </li>
              </ul>
            </Section>

            <Section n={2} title="CCPA — Utenti californiani">
              In conformità al California Consumer Privacy Act:
              <ul style={ulStyle}>
                <li>iPairly non vende dati personali a terze parti</li>
                <li>
                  Gli utenti californiani hanno il diritto di richiedere quali
                  dati personali abbiamo (solo email per utenti Pro)
                </li>
                <li>
                  Gli utenti californiani hanno il diritto di richiedere la
                  cancellazione dei propri dati
                </li>
                <li>
                  Non vi è discriminazione per l'esercizio dei diritti CCPA
                </li>
              </ul>
              Per esercitare questi diritti:{" "}
              <a href={`mailto:${EMAIL}`} style={linkStyle}>
                {EMAIL}
              </a>
            </Section>
          </div>

          {/* Navigazione */}
          <div
            style={{
              display: "flex",
              gap: "1rem",
              flexWrap: "wrap",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: "1rem",
              paddingTop: "2.5rem",
              borderTop: "1px solid var(--color-border)",
            }}
          >
            <Link
              to="/ipairly"
              className="btn-primary"
              style={{ textDecoration: "none" }}
            >
              ← Torna a iPairly
            </Link>
            <Link to="/" style={linkStyle}>
              VMDProject →
            </Link>
          </div>
        </div>

        {/* ─── Footer ─── */}
        <footer
          style={{
            borderTop: "1px solid var(--color-border)",
            padding: "2rem 0",
          }}
        >
          <div
            className="container"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: "1rem",
            }}
          >
            <span
              style={{
                fontFamily: "var(--font-display)",
                fontWeight: 700,
                fontSize: "0.95rem",
              }}
            >
              VMDProject
            </span>
            <div style={{ display: "flex", gap: "1.5rem" }}>
              <Link
                to="/policy"
                style={{
                  fontSize: "0.9rem",
                  color: "var(--color-muted)",
                  transition: "color 0.3s",
                  textDecoration: "none",
                }}
                onMouseEnter={(e) =>
                  (e.target.style.color = "var(--color-text)")
                }
                onMouseLeave={(e) =>
                  (e.target.style.color = "var(--color-muted)")
                }
              >
                Privacy
              </Link>
              <Link
                to="/terms-and-conditions"
                style={{
                  fontSize: "0.9rem",
                  color: "var(--color-muted)",
                  transition: "color 0.3s",
                  textDecoration: "none",
                }}
                onMouseEnter={(e) =>
                  (e.target.style.color = "var(--color-text)")
                }
                onMouseLeave={(e) =>
                  (e.target.style.color = "var(--color-muted)")
                }
              >
                Termini
              </Link>
            </div>
            <span
              style={{
                fontFamily: "var(--font-mono)",
                fontSize: "0.82rem",
                color: "var(--color-muted)",
              }}
            >
              © {new Date().getFullYear()} VMDProject
            </span>
          </div>
        </footer>
      </motion.main>
    </>
  );
}
